export default {
  MOUNTED: 'presentPublicationMounted',
  STABLE: 'presentPublicationStable',
  STABLE_SCROLL: 'presentPublicationStableScroll',
  ERROR: 'positionPresentPublication',
  REFRESH_BOOK: 'refreshBook'
};
